import React from "react";
import PageTitle from "components/PageTitle";
import { tracker } from "library/tracker";
import PrimeInvestMoreContainer from "containers/jarivsPrime/PrimeInvestMore";

const PrimeStartSIP = () => {
  React.useEffect(() => {
    tracker.pageView();
  }, []);

  return (
    <>
      <PageTitle
        heading="Start SIP"
        subheading="How would you like to invest?"
      />
      <PrimeInvestMoreContainer investmentType="SIP" />
    </>
  );
};

export default PrimeStartSIP;
